import { CollectionQuestion } from './../../../../models/questionnaire.model';
import {
  S3FileInput,
  GetAnswerQuery,
  DeleteArtifactsRegistryInput,
  ModelArtifactsRegistryFilterInput,
} from './../../../API.service';
import { NGXLogger } from 'ngx-logger';
import { ToastrService } from 'ngx-toastr';
import { FileService } from './../../../shared/file.service';
import { Component, OnInit, ViewEncapsulation, EventEmitter, Output, Input, OnDestroy } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteModalComponent } from '../../../shared/delete-modal/delete-modal.component';
import { DeleteModalTypeEnum } from '../../../shared/enums/deleteModal.enum';
import { saveAs } from 'file-saver';
import * as JSZip from 'jszip';
import { CollectionService } from '../../collection.service';
import { Subscription } from 'rxjs';
import { getLogMessage } from 'app/shared/helpers/logs.helper';
import { LogsKeyEnum } from 'app/shared/enums/logsKey.enum';
import { EntityService } from 'app/shared/entity.service';
import { CUSTOMAPIService } from 'app/custom-api.service';

class ExistingFiles {
  fileName: string;
  uploadDate: number;
  processed: boolean;
  userName: string;
  userDepartment: string | null;
  userRole: string | null;
  file: S3FileInput;
  selected: boolean;
  answerId: number;
  answer: GetAnswerQuery;

  constructor(
    name: string,
    date: number,
    proc: boolean,
    user: string,
    userDepartment: string | null,
    userRole: string | null,
    file: S3FileInput,
    sel: boolean,
    answerId: number,
    answer: GetAnswerQuery
  ) {
    this.fileName = name;
    this.uploadDate = date;
    this.processed = proc;
    this.userName = user;
    this.userDepartment = userDepartment;
    this.userRole = userRole;
    this.file = file;
    this.selected = sel;
    this.answerId = answerId;
    this.answer = answer;
  }
}

@Component({
  selector: 'cygov-collection-existing-files-first-party',
  templateUrl: './collection-existing-files.component.html',
  styleUrls: ['./collection-existing-files.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CollectionExistingFilesFirstPartyComponent implements OnInit, OnDestroy {
  @Input() answers: GetAnswerQuery[];
  @Input() question: CollectionQuestion;
  @Input() targetId: string;
  @Input() assessmentId: string;
  @Input() type: string;
  @Input() currUserName: string;
  @Input() isArtifactsMandatory: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() questionNo: string | number = '';
  @Input() controlId: string = '';
  @Input() controlName: string = '';
  @Output()
  closeModalClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  updateDeletedFiles: EventEmitter<Array<{ fileId: string; questionId: string; answerId: string }>> = new EventEmitter<
    Array<{ fileId: string; questionId: string; answerId: string }>
  >();
  modalRef: NgbModalRef;
  closeModalInstance = null;

  tableLoading = true;
  deleteModalFlag = false;
  downloadModalFlag = false;
  confirmationMessage = 'Do you really want to delete ?';
  // filterOptions: string[] = ['one', 'two', 'three'];
  subscriptions: Subscription;
  queryText = '';
  filterBy = '';
  progressD = 0;

  exFiles: ExistingFiles[] = [];
  filteredFiles: ExistingFiles[] = [];
  unZippedFiles: any = [];
  sortButtons = { user: 'na', date: 'na' };
  previousSort = '';

  constructor(
    private fileService: FileService,
    private toastrService: ToastrService,
    private logger: NGXLogger,
    private collectionService: CollectionService,
    private entityService: EntityService,
    private customApi: CUSTOMAPIService,
    private modalService: NgbModal
  ) {
    this.subscriptions = new Subscription();
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.collectionService.getSelectedControl().subscribe(control => {
        // Only set controlName if not provided via @Input()
        if (!this.controlName) {
          this.controlName = control.name;
        }
      })
    );

    if (this.answers && this.answers.length) {
      this.buildExistingFilesData();
    } else {
      this.tableLoading = false;
    }
  }

  async buildExistingFilesData(): Promise<void> {
    try {
      this.exFiles = [];

      // Get questionId from the first answer/file
      let questionId: string | undefined;

      // Find first file to get questionId
      for (const answer of this.answers) {
        if (answer?.file?.length) {
          if (answer?.questionId) {
            questionId = answer.questionId;
          }
          break;
        }
      }

      // Fetch all artifacts for this question using ArtifactsByQuestionId
      const artifactNameMap = new Map<string, string>();
      if (questionId) {
        try {
          const filter: ModelArtifactsRegistryFilterInput = {
            assessmentId: { eq: this.assessmentId },
          };

          const allArtifacts: any[] = [];
          let nextToken: string | null | undefined = null;

          // Fetch all artifacts in batches
          do {
            const response = await this.customApi.ArtifactsByQuestionId(
              questionId,
              undefined, // sortDirection
              filter, // filter by assessmentId
              500, // limit
              nextToken || undefined
            );

            if (response?.items) {
              allArtifacts.push(...response.items);
            }

            nextToken = response?.nextToken || null;
          } while (nextToken);

          // Create a map of fileId to artifact name
          allArtifacts.forEach(artifact => {
            if (artifact?.fileId && artifact?.name) {
              artifactNameMap.set(artifact.fileId, artifact.name);
            }
          });
        } catch (error) {
          this.logger.debug(`Failed to fetch artifacts by questionId ${questionId}, will use file names:`, error);
        }
      }

      // Build files using artifact names from the map
      const seenFiles = new Set<string>();
      this.answers.forEach((answer, answerIndex) => {
        if (answer?.file?.length) {
          const selected = true; // select all files of this questions // answer.controlId === this.selectedControl.id;
          const answerUserId = answer?.userId || answer?.user?.id;

          const seenInThisAnswer = new Set<string>();

          answer.file.forEach(eachFile => {
            if (!eachFile || !eachFile.id) {
              return;
            }

            if (seenInThisAnswer.has(eachFile.id)) {
              return;
            }
            seenInThisAnswer.add(eachFile.id);

            const fileKey = `${eachFile.id}_${answerUserId}`;

            if (seenFiles.has(fileKey)) {
              return;
            }

            seenFiles.add(fileKey);

            // Use artifact name from map, fallback to file name
            const artifactName = artifactNameMap.get(eachFile.id) || eachFile.name;

            this.exFiles.push(
              new ExistingFiles(
                artifactName,
                eachFile.date,
                true,
                answer.user?.name || 'Archived User',
                null, // Department not available in user object
                answer.user?.role || null,
                eachFile,
                selected,
                answerIndex,
                answer
              )
            );
          });
        }
      });

      this.filteredFiles = this.exFiles;
      this.tableLoading = false;
    } catch (e) {
      this.tableLoading = false;
      this.toastrService.error('Cannot get file', e);
    }
  }

  async downloadFile(): Promise<void> {
    try {
      if (this.filteredFiles.length !== 0) {
        const entityId = this.filteredFiles[0].file.entityId;
        let count = 0;

        let totalFiles = 0;
        this.filteredFiles.forEach(file => {
          if (file.selected) {
            totalFiles += 1;
          }
        });
        const zipPercent: number = 100 - 100 / totalFiles;
        const blobs = [];
        let checkSelected = false;

        for (const file of this.filteredFiles) {
          if (file.selected) {
            const fileText = totalFiles === 1 ? 'file' : 'files';
            this.toastrService.info(`Preparing ${fileText} to download...`);
            checkSelected = true;

            // Get artifact by questionId and fileId to retrieve parentID
            let downloadFileId = file.file.id;
            const downloadEntityId = file.file.entityId;

            try {
              if (file.file.id && file.answer?.questionId) {
                const filter: ModelArtifactsRegistryFilterInput = {
                  fileId: { eq: file.file.id },
                  assessmentId: { eq: this.assessmentId },
                };
                const artifactResponse = await this.customApi.ArtifactsByQuestionId(
                  file.answer.questionId,
                  undefined,
                  filter,
                  1000
                );
                const artifact = artifactResponse?.items?.[0];
                if (artifact) {
                  downloadFileId = artifact.parentID;
                }
              }
            } catch (error) {
              console.warn(`Failed to fetch artifact ${file.file.id}, using file.id directly:`, error);
            }

            if (downloadFileId && downloadEntityId) {
              file.file.key = `public/ARTIFACTS_REGISTRY/${downloadEntityId}/${downloadFileId}`;
            }

            const url = await this.fileService.downloadFromS3(file.file);
            const response = await fetch(url);
            const reader = response.body.getReader();
            const contentLength: number = +response.headers.get('Content-Length');
            let receivedLength = 0;
            const chunks = [];

            let completion = false;

            while (!completion) {
              const { done, value } = await reader.read();
              if (done) {
                completion = true;
              } else {
                chunks.push(value);
                receivedLength += value.length;
                const total: number = (receivedLength / contentLength) * 100 + count * 100;
                this.progressD = total / totalFiles;
              }
              if (!this.downloadModalFlag) {
                this.progressD = 0;
                return;
              }
            }

            const blob = new Blob(chunks);
            // Use the file name that is displayed in the list
            blobs.push({ blob, name: file.fileName, userName: file.userName });
            count++;
          }
        }

        if (!this.downloadModalFlag) {
          this.progressD = 0;
          return;
        }
        if (checkSelected) {
          const zip = new JSZip();
          if (count === totalFiles) {
            if (blobs.length === 1) {
              const originalFile = await zip.loadAsync(blobs[0].blob);
              const fileName = Object.keys(originalFile.files)[0];
              // Use the file name that is displayed in the list
              const downloadFileName = blobs[0].name; // This is file.fileName from the list
              const fileExtension =
                fileName.split('.').slice(-1)[0] || downloadFileName.split('.').slice(-1)[0] || 'zip';
              originalFile.files[fileName].async('blob').then(data => {
                // Use the displayed file name with proper extension
                if (downloadFileName.includes('.')) {
                  // If file name already has extension, use it as is
                  saveAs(data, downloadFileName);
                } else {
                  // Otherwise, add the extension from the original file
                  saveAs(data, `${downloadFileName}.${fileExtension}`);
                }
              });
              return;
            }
            const promises = [];
            const fileNames = [];
            blobs.forEach(file => {
              promises.push(this.unZip(file));
            });
            await Promise.all(promises);
            this.unZippedFiles.forEach(item => {
              let name;
              if (!fileNames.includes(item.name)) {
                fileNames.push(item.name);
                name = item.name;
              } else {
                fileNames.push(item.name);
                const counter = fileNames.filter(filename => filename === item.name).length - 1;
                name = counter + '_' + item.name;
              }
              zip.file(name, item.file);
            });
            this.unZippedFiles.length = 0;
            fileNames.length = 0;
            const zipFile = await zip.generateAsync({ type: 'blob' }, metaData => {
              this.progressD = parseInt(metaData.percent.toFixed(0), 10) / totalFiles + zipPercent;
            });
            saveAs(zipFile, `Artifacts-${entityId}.zip`);
            const logMessage = getLogMessage(LogsKeyEnum.ARTIFACT_DOWNLOAD, this.currUserName, null, null, totalFiles);
            this.entityService.addLog(this.targetId, this.assessmentId, this.type, logMessage);
          }
        } else {
          this.toastrService.info('No Artifacts Selected');
          this.downloadModalFlag = false;
        }
      }
    } catch (e) {
      this.logger.error(e);
      this.toastrService.error('Failed downloading file');
    }
  }
  async unZip(file): Promise<void> {
    const currentZip = new JSZip();
    const originalFile = await currentZip.loadAsync(file.blob);
    const fileName = Object.keys(originalFile.files)[0];
    const data = await originalFile.files[fileName].async('blob');
    this.unZippedFiles.push({ name: file.name, file: data });
  }
  onKeyUp(): void {
    if (this.queryText && this.queryText.length && this.queryText.length > 1) {
      const filterData = this.exFiles.filter(item =>
        item.fileName.toLowerCase().includes(this.queryText.toLowerCase())
      );
      this.filteredFiles = filterData;
    } else {
      this.filteredFiles = this.exFiles;
    }
    // Reapply current sort if any
    if (this.previousSort && this.sortButtons[this.previousSort] !== 'na') {
      this.sortList(this.sortButtons[this.previousSort], this.previousSort);
    }
  }

  filterChanged(event: any, type: string): void {
    if (type === 'select') {
      this.filterBy = event;
    }
  }

  closeModal(): void {
    this.closeModalClicked.emit(true);
  }
  openDeleteModal(): void {
    const selectedFiles = this.filteredFiles.filter(file => file?.selected);

    if (selectedFiles.length === 0) {
      this.toastrService.info('No Artifacts Selected');
      return;
    }

    // Get the first selected file's question information
    const firstFile = selectedFiles[0];
    const relevantAnswer: any = firstFile.answer;
    const questionObj: any = this.question;

    // Construct question identifier: "Framework Name | SubEntity, Control ID: XXX, Question YY"
    // Use passed inputs first, then fallback to answer/question objects
    const frameworkName = questionObj?.standards;
    const controlName = this.controlName || '';
    const finalControlId = this.controlId || relevantAnswer?.controlId || questionObj?.controlId || '';
    const finalQuestionNo = this.questionNo || '';

    const questionIdentifier =
      `${frameworkName}${controlName ? ' | ' + controlName : ''}, ` +
      `Control ID: ${finalControlId}, Question ${finalQuestionNo}`;

    const modalRef = this.modalService.open(DeleteModalComponent, {
      size: 'sm',
      windowClass: 'delete-layer-confirm-modal delete-collection-framework-modal',
      backdropClass: 'delete-layer-confirm-backdrop',
      backdrop: 'static',
    });

    modalRef.componentInstance.modalType = DeleteModalTypeEnum.UNLINK_ARTIFACT;
    modalRef.componentInstance.questionIdentifier = questionIdentifier;
    modalRef.componentInstance.artifactsCount = selectedFiles.length;
    modalRef.componentInstance.titleText = '';
    modalRef.componentInstance.deleteEntityModal = false;
    modalRef.componentInstance.isFromScans = true;

    // Override confirmLevel to handle unlink confirmation
    const originalConfirmLevel = modalRef.componentInstance.confirmLevel.bind(modalRef.componentInstance);
    modalRef.componentInstance.confirmLevel = () => {
      if (
        modalRef.componentInstance.modalType === DeleteModalTypeEnum.UNLINK_ARTIFACT &&
        modalRef.componentInstance.confirmationString?.toLowerCase() === 'confirm'
      ) {
        // Close modal first
        modalRef.close();
        // Then trigger deletion
        setTimeout(() => {
          this.deletingFiles();
        }, 100);
      } else {
        // Call original method for other cases
        originalConfirmLevel();
      }
    };

    this.closeModalInstance = modalRef;
  }

  closeDeleteModal(): void {
    this.deleteModalFlag = false;
  }
  openDownloadModal(): void {
    if (!this.hasSelectedFiles()) {
      return;
    }
    this.downloadModalFlag = true;
  }
  closeDownloadModal(closeDownloadloadModalFlag: boolean): void {
    if (closeDownloadloadModalFlag) {
      this.progressD = 0;
      this.downloadModalFlag = false;
    }
  }
  async deletingFiles(): Promise<void> {
    const filesToDelete = [];
    const selectedArtifacts = [];
    // this filter filter out all the files that are not selected
    this.filteredFiles.forEach(file => {
      if (file.selected) {
        // getting all selected artifacts
        selectedArtifacts.push(file);
      }
      return file;
    });
    if (selectedArtifacts.length > 0) {
      if (selectedArtifacts.length === this.filteredFiles.length && this.isArtifactsMandatory) {
        this.toastrService.info('At least one file is required for artifacts mandatory questions');
      } else {
        selectedArtifacts.forEach(artifact => {
          filesToDelete.push({
            fileId: artifact.file.id,
            questionId: artifact.answer.questionId,
            answerId: artifact.answer.id,
          });
        });

        // Delete from artifacts-registry
        await this.deleteArtifactsRegistry(filesToDelete);

        this.updateDeletedFiles.emit(filesToDelete);
        this.toastrService.success('Files deleted');
        this.filteredFiles = this.filteredFiles.filter(file => !file.selected);
        this.exFiles = this.exFiles.filter(file => !file.selected);
        // Reapply current sort if any
        if (this.previousSort && this.sortButtons[this.previousSort] !== 'na') {
          this.sortList(this.sortButtons[this.previousSort], this.previousSort);
        }
      }
    } else {
      this.toastrService.info('No Artifacts Selected');
    }
  }

  async deleteAllFiles(): Promise<void> {
    await this.deletingFiles();
  }

  async deleteArtifactsRegistry(
    filesToDelete: Array<{ fileId: string; questionId: string; answerId: string }>
  ): Promise<void> {
    try {
      const deletePromises = filesToDelete.map(async file => {
        try {
          // Get the artifact registry by questionId with fileId filter
          const filter: ModelArtifactsRegistryFilterInput = {
            fileId: { eq: file.fileId },
            assessmentId: { eq: this.assessmentId },
          };
          const response = await this.customApi.ArtifactsByQuestionId(file.questionId, undefined, filter, 1000);

          // Get the first matching artifact
          const artifact = response?.items?.[0];

          // Verify it matches answerId
          if (artifact && artifact.answerId === file.answerId) {
            const deleteInput: DeleteArtifactsRegistryInput = {
              id: artifact.id, // Use the ID from the fetched artifact
            };
            await this.customApi.DeleteArtifactsRegistry(deleteInput, {
              entityId: {
                eq: artifact.entityId,
              },
            });
            this.logger.debug(`Deleted artifact registry with id: ${artifact.id}`);
          } else {
            this.logger.warn(
              `Artifact registry ${file.fileId} does not match questionId or answerId, skipping deletion`
            );
          }
        } catch (error) {
          // If artifact doesn't exist or other error, log but don't fail the entire operation
          this.logger.warn(`Failed to delete artifact registry ${file.fileId}:`, error);
        }
      });

      await Promise.all(deletePromises);
    } catch (error) {
      this.logger.error('Error deleting artifacts from registry:', error);
      // Don't throw - allow file deletion to continue even if registry deletion fails
    }
  }

  selectedRow(i: number): void {
    this.filteredFiles[i].selected = !this.filteredFiles[i].selected;
  }

  hasSelectedFiles(): boolean {
    return this.filteredFiles.some(file => file.selected);
  }

  sortList(type: string, col: string): void {
    if (this.previousSort !== '') {
      this.sortButtons[this.previousSort] = 'na';
      this.previousSort = col;
      this.sortButtons[col] = type;
    } else {
      this.previousSort = col;
      this.sortButtons[col] = type;
    }

    this.filteredFiles.sort((a, b) => {
      if (col === 'user') {
        const nameA = (a.userName || '').toUpperCase();
        const nameB = (b.userName || '').toUpperCase();

        if (nameA < nameB) {
          return type === 'asc' ? -1 : 1;
        }
        if (nameA > nameB) {
          return type === 'asc' ? 1 : -1;
        }
        return 0;
      } else if (col === 'date') {
        const dateA = a.uploadDate || 0;
        const dateB = b.uploadDate || 0;
        return type === 'asc' ? dateA - dateB : dateB - dateA;
      }
      return 0;
    });
  }

  capitalizeFirstLetter(str: string): string {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    if (this.closeModalInstance) {
      this.closeModalInstance.close();
    }
  }
}
